import { inject, Injectable, LOCALE_ID } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FormatService {
  private locale = inject(LOCALE_ID);

  formatCoinCurrency(amount: number | string | null | undefined, precision = 0, currency?: string): string {
    const numericAmount = Number(amount);

    if (amount === null || amount === undefined || Number.isNaN(numericAmount)) {
      return '—';
    }

    const hasCurrency = !!currency && currency.trim().length > 0;
    const truncatedAmount = this.truncateAmount(numericAmount, precision);

    const formatter = new Intl.NumberFormat(this.locale, {
      style: hasCurrency ? 'currency' : 'decimal',
      ...(hasCurrency && { currency }),
      minimumFractionDigits: hasCurrency ? precision : 0,
      maximumFractionDigits: precision,
    });

    return formatter.format(truncatedAmount);
  }

  private truncateAmount(amount: number, precision: number): number {
    if (!precision) {
      return Math.trunc(amount);
    }

    const factor = Math.pow(10, precision);
    const scaledAmount = amount * factor;
    const adjustment = Math.sign(scaledAmount) * Number.EPSILON * Math.max(1, Math.abs(scaledAmount));

    return Math.trunc(scaledAmount + adjustment) / factor;
  }
}
